<template>
  <v-container>
    <template v-if="user">
      <v-row v-for="n in rowCount" :key="n">
        <v-col v-for="(m, i) in rowModules(n)" cols="12" sm="6" :key="m + i"
          offset-lg="{1 : i === 0}" lg="5" offset-xl="{2 : i === 0}" xl="4"
        >
          <v-hover v-slot:default="{ hover }">
            <v-card
              width="100%" class="mx-auto"
              :elevation="hover ? 12 : 2"
              :to="m.link"
            >
              <v-card-title>{{ m.name }}</v-card-title>
              <v-card-text class="card-session">
                <div class="session-container" :style="{ backgroundImage: 'url(' + assetRoot + '/' + m.image + ')' }">
                  {{ m.text }}
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class Home extends Vue {
  @Getter user
  @Getter assetRoot
  @Getter apps

  get rowCount () {
    return Math.ceil(this.apps.length / 2)
  }

  rowModules (n) {
    const start = (n - 1) * 2
    return this.apps.slice(start, start + 2)
  }
}
</script>

<style lang="scss" scoped>
.card-session {
  width: 300px;
  height: 300px;
  opacity: 0.65;
  .session-container {
    position: absolute;
    width: 240px;
    height: 240px;
    left: 50%;
    margin-left: -120px;
    background-size: cover;
  }
}
</style>
